import { FunctionComponent, useState } from 'react'
import { Button, CreatePortfolioItemModal } from '../../../components'
import { User } from '../../../gql/types'
import { Header } from '../components/Header'
import { PortfolioGridNew } from '../../../components/PortfolioGridNew'

interface IProps {
  user: User
}

const CreatorPortfolio: FunctionComponent<IProps> = ({ user }) => {
  const [isCreatePortfolioItemModalOpen, setIsCreatePortfolioItemModalOpen] =
    useState(false)

  return (
    <div>
      <Header />

      <CreatePortfolioItemModal
        creator={user.creator}
        isOpen={isCreatePortfolioItemModalOpen}
        setIsOpen={setIsCreatePortfolioItemModalOpen}
      />

      <div className='mb-2 sm:flex-none'>
        <Button
          title='Upload video to your portfolio'
          type='button'
          onClick={() => setIsCreatePortfolioItemModalOpen(true)}
        />
      </div>

      <p
        className={`text-sm mt-2 ${
          user?.creator?.portfolioItemsCount < user?.creator?.minPortfolioItems
            ? 'text-red-600'
            : 'text-gray-500'
        }`}
      >
        {user?.creator?.portfolioItemsCount < user?.creator?.minPortfolioItems
          ? '! '
          : '· '}
        Upload {user?.creator?.minPortfolioItems} or more videos from your
        previous collaborations to show quality and variety of your content
        styles.
      </p>

      <PortfolioGridNew
        creator={user?.creator}
        allowDownload={true}
        allowDelete={true}
      />
    </div>
  )
}

export { CreatorPortfolio }
